/* eslint-disable */
const state = {
  homeIsSearch: 1, // 用于首页判断是否是搜索状态 1-非搜索 2-搜索商品 3-搜索分类
  homeGoodStore: 1, // 1-选好物 2-逛店铺
  sureOrderInfo: null, // 保存普通商品确认订单页数据
  groupActivityType: null, // 保存拼团活动类型 1-普通拼团 2-阶梯拼团 3-超级拼团
  groupActivityId: null, // 保存拼团活动ID
  userSelect: null, // 用户选择商品信息
  serviceDetail: null, // 服务详情
  currentSearchInfo: null, // 搜索信息
  currentSearchClassId: null, // 搜索分类id
  currentStoreType: null, // 当前店铺类型
  currentSearchClassId: null, // 搜索分类id
  timeLimitStatusOrder: null, // 限时抢购页面的状态 1-正在疯抢 2-即将开抢 3-已结束
  groupActivityStatusOrder: null // 拼团活动页面的状态 1-拼团中 2-即将开团 3-已结束
}

const getters = {
  
}

const actions = {

}

const mutations = {
  setCurrentStoreType(state, value) {
    state.currentStoreType = value
  },
  setSearchInfo(state, value) {
    state.currentSearchInfo = value
  },
  setSearchClassId(state, value) {
    state.currentSearchClassId = value
  },
  setHomeIsSearch(state, value) {
    if (
      !value || 
      ![1, 2, 3].includes(Number(value))
    ) {
      return
    }
    state.homeIsSearch = value
  },
  setHomeGoodStore(state, value) {
    if (
      !value || 
      ![1, 2].includes(Number(value))
    ) {
      return
    }
    state.homeGoodStore = value
  },
  setSureOrderInfo(state, value) {
    if (JSON.stringify(value) === '{}') {
      state.sureOrderInfo = null
      sessionStorage.setItem('sureOrderInfo', JSON.stringify(value))
      return
    }
    state.sureOrderInfo = value
    sessionStorage.setItem('sureOrderInfo', JSON.stringify(value))
  },
  setGroupActivityType(state, value) {
    if (!value || ![1, 2, 3].includes(Number(value))) {
      return
    }
    state.groupActivityType = value
  },
  setGroupActivityId(state, value) {
    if (!value) {
      return
    }
    state.groupActivityId = value
  },
  setUserSelect(state, value) {
    state.userSelect = value
  },
  removeUserSelect(state, value) {
    state.userSelect = null
  },
  setServiceDetail(state, value) {
    state.serviceDetail = value
  },
  setTimeLimitStatusOrder(state, value) {
    state.timeLimitStatusOrder = value
  },
  setGroupActivityStatusOrder(state, value) {
    state.groupActivityStatusOrder = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
